export enum StatusWeryfikacjiZgodnosciZOryginalem {
  NieSprawdzono = 1,
  ZgodnyZOryginalem,
  NieZgodnyZOryginalem,
}
